import {ReactDropzone} from '@crema/modules/thirdParty';

export default ReactDropzone;
